const TRUE_VALUES = new Set(["true", "1", "yes", "on"]);

function readBoolean(value, fallback = false) {
  if (value === undefined || value === null || value === "") return fallback;
  return TRUE_VALUES.has(String(value).trim().toLowerCase());
}

export const TAMBO_LITE_MODE = readBoolean(
  process.env.VUE_APP_TAMBO_LITE_MODE,
  false
);

export const TAMBO_LITE_LABEL =
  process.env.VUE_APP_TAMBO_LITE_LABEL || "Tambo Lite Beta";

export const TAMBO_LITE_API_BASE_URL =
  process.env.VUE_APP_API_TAMBO || "http://localhost:8000";

export const TAMBO_LITE_ALLOWED_ROUTE_NAMES = Object.freeze([
  "landing",
  "vaquiano",
  "baquiano",
  "tfp",
  "tfpDev",
  "tfpAgro",
  "terms",
  "suscripciones",
  "login",
  "register",
  "forgotPassword",
  "tambos",
  "inicio",
  "participantes",
  "despachos",
  "empresas",
  "vacas",
  "lotes",
  "veterinario",
  "estadisticas",
  "ventas",
  "sinAcceso",
]);

export const TAMBO_LITE_DISABLED_MODULES = Object.freeze([
  "feedlot",
  "siembras",
  "maquinaria",
  "ocr",
  "integraciones externas",
  "erp",
  "fiscal",
  "contabilidad",
  "market references",
  "ordenes",
  "suscripciones",
  "jobs automaticos",
]);

export const TAMBO_LITE_BACKEND_ENDPOINT_PREFIXES = Object.freeze([
  "/register",
  "/login",
  "/refresh",
  "/logout",
  "/forgot-password",
  "/reset-password",
  "/change-password",
  "/roles-info",
  "/mis-tambos",
  "/tambos",
  "/usuarios/tambo-actual",
  "/invitaciones",
  "/lotes_vacas",
  "/grilla_vaca",
  "/ventas",
  "/empresas",
  "/despachos",
  "/estadisticas/resumen-tambo",
  "/estadisticas/tambo",
  "/empleados",
  "/inventario_veterinario",
]);

export const liteBetaConfig = Object.freeze({
  enabled: TAMBO_LITE_MODE,
  label: TAMBO_LITE_LABEL,
  apiBaseUrl: TAMBO_LITE_API_BASE_URL,
  allowedRouteNames: TAMBO_LITE_ALLOWED_ROUTE_NAMES,
  disabledModules: TAMBO_LITE_DISABLED_MODULES,
  backendEndpointPrefixes: TAMBO_LITE_BACKEND_ENDPOINT_PREFIXES,
});
